<template>

  <v-container>
    <ResetPinModal :showModal="shouldShowModal" />
    <v-card class="dt-border pad-10" flat>
      <v-container>
        <div class="d-flex justify-end">
          <v-menu v-model="topCardMenu" style="box-shadow: none" :close-on-content-click="false" :close-on-click="false"
            :nudge-width="100" min-width="300" max-width="300" class="menu dt-border" offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" outlined rounded dark v-bind="attrs" v-on="on">
                <v-icon> mdi-filter-variant </v-icon>
                filter
              </v-btn>
            </template>
            <v-card class="pa-5" flat>
              <label for="">Date</label>
              <br />
              <DateRangePicker v-model="topCardDateRange" />
              <v-card-actions>
                <v-btn rounded depressed @click="resetTopCard">Reset</v-btn>
                <v-btn color="primary" @click="getUserDashboard()" rounded depressed>Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
        <Box :details="details" />
      </v-container>
    </v-card>

    <v-row class="mt-5">
      <v-col md="8" cols="12">

        <v-card class="dt-border pad-10" flat>
          <v-row>
            <v-col>
              <div class="d-flex justify-end">
                <v-menu v-model="menu" style="box-shadow: none" :close-on-content-click="false" :close-on-click="false"
                  :nudge-width="100" min-width="300" max-width="300" class="menu dt-border" offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" outlined rounded dark v-bind="attrs" v-on="on">
                      <v-icon> mdi-filter-variant </v-icon>
                      filter
                    </v-btn>
                  </template>
                  <v-card class="pa-5" flat>
                    <label for="">Date</label>
                    <br />
                    <DateRangePicker v-model="dateRange" />
                    <v-card-actions>
                      <v-btn rounded depressed @click="reset">Reset</v-btn>
                      <v-btn color="primary" @click="getIncomeOutcome()" rounded depressed>Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
              <div v-if="false">
                <v-select @change="filterBarChat" class="float-end" label="view data for" v-model="barchat"
                  :items="['Current Week', 'Last Week', '2023', '2022']"></v-select>
              </div>
            </v-col>
          </v-row>
          <v-container>
            <line-chart :key="componentKey" :chartProp="chartProp" />


          </v-container>

        </v-card>
      </v-col>
      <v-col md="4" cols="12">
        <v-row>

          <v-col> <v-card class="dt-border pad-10" flat>
              <v-container>
                <p>Total Credit</p>
                <p>{{ formatMoney(tradesSummary.tradesTotal.totalAmount || 0) }}</p>
              </v-container>
            </v-card></v-col>

          <v-col> <v-card class="dt-border pad-10" flat>
              <v-container>
                <p>Withdrawals</p>
                <p>{{ formatMoney(tradesSummary.withdrawalTotal.totalAmount || 0) }}</p>
              </v-container>
            </v-card></v-col>
        </v-row>
        <v-row>
          <v-col class="avatar-md">
            <v-card class="text-center pt-5 pb-3">
              <h3 class="text-start pl-3">Top 5 Traders</h3>
              <v-avatar>
                <img
                  :src="topTradersUsers[0].profilepicture || 'https://www.svgrepo.com/show/452030/avatar-default.svg'"
                  :title="topTradersUsers[0].firstname" :alt="topTradersUsers[0].firstname">
              </v-avatar>
              <v-avatar class="move-forward">
                <img
                  :src="topTradersUsers[1].profilepicture || 'https://www.svgrepo.com/show/452030/avatar-default.svg'"
                  :title="topTradersUsers[1].firstname" :alt="topTradersUsers[1].firstname">
              </v-avatar>
              <v-avatar class="move-forward">
                <img
                  :src="topTradersUsers[2].profilepicture || 'https://www.svgrepo.com/show/452030/avatar-default.svg'"
                  :title="topTradersUsers[2].firstname" :alt="topTradersUsers[2].firstname">

              </v-avatar>
              <v-avatar class="move-forward">
                <img
                  :src="topTradersUsers[3].profilepicture || 'https://www.svgrepo.com/show/452030/avatar-default.svg'"
                  :title="topTradersUsers[3].firstname" :alt="topTradersUsers[3].firstname">

              </v-avatar>
              <v-avatar class="move-forward">
                <img
                  :src="topTradersUsers[4].profilepicture || 'https://www.svgrepo.com/show/452030/avatar-default.svg'"
                  :title="topTradersUsers[4].firstname" :alt="topTradersUsers[4].firstname">

              </v-avatar>
              <router-link to="/promo/rankings/traders">
                <v-avatar style="margin-left:12px; color:white; background-color: orange;">
                  {{ topTradersUsers.length - 5 }}+
                </v-avatar>
              </router-link>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-5">

      <v-col cols="12" md="12">
        <SimpleTable :mytransactions="mytransactions" />
      </v-col>


    </v-row>

    <v-row class="mt-5">

      <v-col>
        <v-card class="dt-border pad-10" flat>
          <v-card-title>
            <h2>Total Giftcard Traded</h2>
            <v-spacer></v-spacer>
            <v-menu v-model="giftCardMenu" style="box-shadow: none" :close-on-content-click="false"
              :close-on-click="true" :nudge-width="100" min-width="300" max-width="300" class="menu dt-border" offset-y
              left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" outlined rounded dark v-bind="attrs" v-on="on">
                  <v-icon> mdi-filter-variant </v-icon>
                  filter
                </v-btn>
              </template>
              <v-card class="pa-5" flat>
                <label for="">Status</label>
                <v-select :items="['approved', 'declined']" v-model="giftCardStatus" item-text="text" item-value="key"
                  dense outlined return-object></v-select>
                <v-card-actions>
                  <v-btn rounded depressed @click="resetGiftCard">Reset</v-btn>
                  <v-btn color="primary" @click="getTopCards()" rounded depressed>Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-card-title>
          <v-container>
            <Pie :pieProps="pieProps" :key="pieKey" />
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Box from "../components/box.vue";
import Pie from "../components/pie.vue";
import LineChart from "../components/line-chart.vue";
import SimpleTable from "../components/simple-table.vue";
import ResetPinModal from '../components/reset-pin.vue'

// import sound from '@/assets/Global/Sounds/notify.wav'

// =========== IMPORT SERVICE =========
import { UsersService } from "@/services";
import { StoresService } from "@/services";
import { formatMoney } from '@/utils/moneyFormatter';
import DateRangePicker from "@/components/DateRangePicker.vue";


export default {
  data: () => ({
    details: {},
    shouldShowModal: false,
    componentKey: 0,
    pieKey: 0,
    barchat: '2022',
    pieProps: {},
    topTradersUsers: [],
    mytransactions: [],
    chartProp: {},
    transactions: [],
    tradesSummary: {},
    items: ["02 August 2020"],
    menu: false,
    dateRange: {
      startDate: new Date(new Date().getFullYear(), 0, 2),
      endDate: new Date(),
    },
    topCardMenu: false,
    topCardDateRange: {},
    giftCardStatus: 'approved',
    config: {
      mode: 'range',
      maxDate: 'today'
    }
  }),
  mounted() {
    this.checkIfPinSet();
    this.getUserDashboard();
    this.getTradesSummary();
    this.getIncomeOutcome();
    this.getToptransactions();
    this.getTopTraders();
    this.getTopCards();
  },
  methods: {
    // notify(){
    //   let notification = new Audio(sound);
    //   notification.play();
    // }

    async checkIfPinSet() {
      let data = await StoresService.pinStatus();
      if (data.data == false) this.shouldShowModal = true
    },

    async getUserDashboard() {
      if (!this.can('can_view_users')) return;
      try {

        this.loading = true;
        const data = await UsersService.dashboardDetails(this.topCardDateRange);
        this.details = data;
        this.loading = false;
        this.topCardMenu = false;
      } catch (error) {
        this.loading = false;
        this.topCardMenu = false;
      }
    },

    async getTradesSummary() {
      if (!this.can('can_view_giftcard_trades')) return;
      try {

        this.loading = true;
        const data = await StoresService.loadTradesWithdrawalSummary();
        if (data.tradesTotal.total_amount == null) { data.tradesTotal.total_amount = 0; console.log('storage') }
        if (data.withdrawalTotal.total_amount == null) { data.withdrawalTotal.total_amount = 0; console.log('storage') }
        this.tradesSummary = data;
      } catch (error) {
        this.loading = false;
      }
    },
    async filterBarChat() {
      if (this.barchat == 'Current Week') this.barchat = 'current';
      if (this.barchat == 'Last Week') this.barchat = 'last';
      await this.getIncomeOutcome(this.barchat);
      this.componentKey += 1; // update the key value
      // update the barchart data based on selection of data

    },
    async getIncomeOutcome() {
      if (!this.can('can_view_transactions')) return;
      this.loading = true;
      this.componentKey = 0;
      const data = await StoresService.loadIncomeOutcome({
        from: new Date(this.dateRange.startDate).toISOString().split("T")[0],
        to: new Date(this.dateRange.endDate).toISOString().split("T")[0]
      });
      this.menu = false
      this.chartProp.label = [];
      this.chartProp.income = [];
      this.chartProp.outcome = [];
      const monthOrder = [
        "January", "February", "March", "April", "May",
        "June", "July", "August", "September", "October",
        "November", "December"
      ];
      data.income.map((e) => {
        this.chartProp.label.push(e.monthName);
      })
      data.outcome.map((e) => {
        this.chartProp.label.push(e.monthName);
      })

      this.chartProp.label = [...new Set(this.chartProp.label)].sort((a, b) => {
        return monthOrder.indexOf(a) - monthOrder.indexOf(b);
      });

      this.chartProp.income = this.chartProp.label.map((e) => {
        let index = data.income.findIndex((x) => x.monthName == e);
        return index == -1 ? 0 : data.income[index].totalAmount;
      })

      this.chartProp.outcome = this.chartProp.label.map((e) => {
        let index = data.outcome.findIndex((x) => x.monthName == e);
        return index == -1 ? 0 : data.outcome[index].totalAmount;
      })


      if (data) this.componentKey = 1;


    },
    async getToptransactions() {
      if (!this.can('can_view_transactions')) return;
      try {
        this.mytransactions = [];
        this.loading = true;
        let data = await UsersService.toptransactions();
        this.loading = false;
        this.mytransactions = data;
      } catch (error) {
        this.loading = false;
      }
    },
    async getTopTraders() {
      if (!this.can('can_view_users') || !this.can('can_view_crypto_transaction')) return;
      try {
        this.
          topTradersUsers = [];
        this.loading = true;
        let data = await StoresService.loadTopTraders();
        this.loading = false;
        this.topTradersUsers = data;
      } catch (error) {
        this.loading = false;
      }
    },
    async getTopCards() {
      if (!this.can('can_view_giftcards')) return;
      try {
        this.pieKey = 0;
        const colorList = [
          '#FF0000', '#00FF00', '#0000FF', '#32cd32', '#6495ed',
          '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0',
          '#8B0000', '#FF00FF', '#7FFFD4', '#2F4F4F', '#228B22',
          '#FA8072', '#E6E6FA', '#008080', '#800000', '#808000',
          '#87cefa', '#da70d6', '#4B0082', '#FF1493', '#9400D3',
          '#B22222', '#483D8B', '#556B2F', '#7B68EE', '#191970',
          '#A0522D', '#FF8C00', '#D2691E', '#FF4500', '#CD5C5C',
          '#F0E68C', '#FF6347', '#DB7093', '#DA70D6', '#B0E0E6',
          '#FFE4E1', '#F08080', '#ADD8E6', '#FFC0CB', '#FFA500'
        ];

        this.
          pieProps = { label: [], data: [], colors: [] };
        this.loading = true;
        let data = await StoresService.loadTopCards(this.giftCardStatus);
        data.forEach((props, i) => {
          this.pieProps.label.push(props.name);
          this.pieProps.data.push(props.amount);
          this.pieProps.colors.push(colorList[i]);
        });
        if (data.length) {
          this.pieKey = 1;
        }

      } catch (error) {
        this.loading = false;
      }
    },
    formatMoney(amount) {
      return formatMoney(amount);
    },
    reset() {
      this.dateRange = {
        startDate: new Date(new Date().getFullYear(), 0, 2),
        endDate: new Date(),
      };
      this.getIncomeOutcome();
      this.menu = false;
    },
    resetTopCard() {
      this.topCardDateRange = {
        startDate: null,
        endDate: null,
      };
      this.getUserDashboard();
      this.topCardMenu = false;
    },
  },
  components: {
    Box,
    LineChart,
    SimpleTable,
    Pie,
    ResetPinModal,
    DateRangePicker,
  },
};
</script>


<style lang="scss">
@import "@/assets/Global/scss/variables.scss";

h2 {
  color: $Dtunes-text;
}

.move-forward {
  margin-left: -15px;
}
</style>